import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { GS1SpinnerDirective } from '@gs1france/gs1-components-library';
import { OAuthErrorEvent, OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { tap } from 'rxjs';
@Component({
  selector: 'autologin',
  imports: [GS1SpinnerDirective],
  template: '<section style="display: flex; justify-content: center; align-items: center; height: 100vh;"><div gs1Spinner [big]="true" size="5rem"></div></section>'
})
export class AutoLoginComponent {
  router = inject(Router);
  oAuthService = inject(OAuthService);

  constructor() {
    // Check if we can proceed immediately
    if (this.oAuthService.hasValidAccessToken()) {
      this.router.navigate(['/signin-oidc']);
      return;
    }

    // Discovery document is already loaded by AppComponent just proceed with login flow
    this.login();

    // Subscribe to future events for error handling only
    this.oAuthService.events
      .pipe(
        takeUntilDestroyed(),
        tap((event: OAuthEvent) => {
          if (event instanceof OAuthErrorEvent) {
            console.error('AutoLoginComponent OAuth error:', event);
          }
        })
      )
      .subscribe();
  }

  login() {
    // Check if already authenticated
    if (this.oAuthService.hasValidAccessToken()) {
      this.router.navigate(['/signin-oidc']);
      return;
    }

    // Try to process OAuth callback (if returning from provider)
    this.oAuthService.tryLogin().then((hasToken) => {
      if (hasToken) this.router.navigate(['/signin-oidc']); // Successfully processed callback
      else this.oAuthService.initLoginFlow(); // No callback and no token → start OAuth flow
    });
  }
}
